export default "__VITE_ASSET__DlqkaF5w__"